import Box from '@mui/material/Box';
import SearchIcon from '@mui/icons-material/Search';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ChoiceField from '../common/ChoiceField';
import {getLocationTypes} from '../../helpers/selectOptions';
import {
  useGetProviderAvailabilitiesQuery
} from '../../redux/services/providerAvailabilityApi';

const PatientSchedulingServiceForm = ({
  onSubmit,
  stepNum = 5,
  providerAvailabilityId,
  serviceCategory,
  subtitle = 'Which location do you prefer for your session?',
}) => {
  const providerAvailabilityQuery = useGetProviderAvailabilitiesQuery(
    {id: providerAvailabilityId},
    {skip: !providerAvailabilityId}
  );
  const availability = providerAvailabilityQuery?.data?.data?.[0];
  const config = (availability?.configs || []).find(c =>
    serviceCategory &&
    c?.session_type?.service_category === serviceCategory
  );
  console.log('availability', providerAvailabilityId, availability, config);
  const options = getLocationTypes()
    .filter(lt => (config?.location_types || []).includes(lt.value))
    .map(cat => ({
      label: cat.label,
      value: cat.value,
      // emoji: cat.emoji,
      description: cat.description,
      color: cat.colorName,
      xs: 12,
      md: 6,
      lg: 6,
      xl: 4,
    }));
  return (
    <Stack spacing={1} alignItems='center'>
      <Typography variant='h2'>Step {stepNum}: Preferred Location</Typography>
      <Typography>{subtitle}</Typography>
      <Box style={{width: '100%'}}>
        <ChoiceField
          choiceStyle='card'
          options={options.map(o => ({...o}))}
          useColoredBackground={false}
          onChange={(e, val) => onSubmit(e, val)}
        />
      </Box>
    </Stack>
  );
};

export default PatientSchedulingServiceForm;